import * as React from 'react'

function SvgBulb(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 24 30" width="0.8em" height="1em" {...props}>
			<path
				fill="currentColor"
				d="M0 12v-2h2.996c-.02.33-.04.662-.04 1.007 0 .34.02.668.044.993zm1.77 6L1 16.37 4.208 15c.237.564.508 1.1.792 1.62zM24 16.286L23.3 18 20 16.676c.286-.535.555-1.095.796-1.676zM4.248 8L2 6.293 2.875 5 5 6.615A7.883 7.883 0 004.248 8zm13.138-7L19 1.75 17.61 4c-.51-.294-1.05-.548-1.61-.759zM20 6.616L22.126 5 23 6.292 20.752 8A7.89 7.89 0 0020 6.616zM7.39 4L6 1.751 7.614 1 9 3.24A11.02 11.02 0 007.39 4zM11 1.993V0h2v2a16.125 16.125 0 00-2-.007zM24 12h-3c.024-.325.045-.653.045-.993 0-.345-.02-.676-.041-1.006H24zm-5-.87c0 4.41-3.75 7.391-3.75 10.87h-6.5C8.75 18.521 5 15.54 5 11.13 5 6.531 8.498 4 11.997 4 15.497 4 19 6.534 19 11.13zm-5.319 18.652a1.11 1.11 0 01-.683.218h-.995c-.26 0-.512-.08-.683-.218L10 29h5zM15 26.5c0 .276-.269.5-.6.5H9.6c-.331 0-.6-.224-.6-.5s.269-.5.6-.5h4.8c.331 0 .6.224.6.5zm0-2c0 .276-.269.5-.6.5H9.6c-.331 0-.6-.224-.6-.5s.269-.5.6-.5h4.8c.331 0 .6.224.6.5z"
			/>
		</svg>
	)
}

export default SvgBulb
